import { GapFillerQueryParams } from '@customTypes/GapFiller'
import { getGroupedAvailabilities } from 'src/services/api/availabilities'
import { CommonQueryParams } from './getQueryParams'
import { GetQueryKey } from './types'

type GetQueryKeyType = (
  commonParams: CommonQueryParams,
  queryParams: GapFillerQueryParams
) => GetQueryKey<ReturnType<typeof getGroupedAvailabilities>>

const today = new Date()
const next72Hours = new Date()
next72Hours.setHours(next72Hours.getHours() + 72)

export const getGapFillerQueryParams: GetQueryKeyType = ({ clinicReferenceId }, { appointmentBundleReferenceId }) => {
  const queryParams = {
    appointmentBundleReferenceId,
    clinicReferenceId,
  }

  return [
    ['gapFillerAvailabilities', queryParams],
    async () => {
      const response = await getGroupedAvailabilities(queryParams, [today, next72Hours])
      const availabilities = response[clinicReferenceId]

      // NOTICE we should filter our empty days for gap filler
      const filteredWeeks = availabilities.weeks.map((week) => {
        return week.filter(({ availabilities }) => availabilities.length > 0)
      })

      return { ...response, [clinicReferenceId]: { ...availabilities, weeks: filteredWeeks } }
    },
  ]
}
